import { makeStyles, Paper, Theme, Typography } from "@material-ui/core";
import Images from "../../../assets/images";
import MyTheme from "../../../assets/theme/MyTheme";

const useStyle = makeStyles((theme: Theme) => ({
    paperRoot: {
        // backgroundColor: '#B9BF14',
        width: '100%',
        borderRadius: 25,
    },

    paperElevation: {
        border: 2,
        borderColor: theme.palette.secondary.light,
        borderStyle: 'solid'
    },

    content: {
        padding: 10,

        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            padding: 5
        },

        display: 'flex',
        color: 'white',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        transition: MyTheme.transition.all
    },

    titel: {
        transition: MyTheme.transition.all,
        color: theme.palette.secondary.light,

        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            fontSize: 26
        },
    },

    logo: {
        position: 'relative',
        minWidth: 80
    },

    logoImg: {
        display: 'block',
        width: 'auto',
        position: 'absolute',
        transition: MyTheme.transition.all,
        left: -35,
        height: 125,
        top: -60,

        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            left: -33,
            height: 100,
            top: -50
        },
    },

    plus: {
        fontWeight: 'bold',
        transform: 'scale(2)',
        paddingRight: 10,
        paddingLeft: 20,
        transition: MyTheme.transition.all,
        color: theme.palette.secondary.light,

        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 10,
            transform: 'scale(1.5)',
        },
    },

}));

const ProduktLogo: React.FC = () => {
    const classes = useStyle();

    return (
        <div style={{ display: 'flex' }}>

            <Paper className={classes.paperRoot} elevation={11} classes={{ elevation11: classes.paperElevation }} >
                <div className={classes.content}>
                    {/* Logo */}
                    <div className={classes.logo}>
                        <img className={classes.logoImg} src={Images.schild} alt="Hunde-Haftpflicht Plus" />
                    </div>

                    {/* Titel */}
                    <div style={{ flexGrow: 2 }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Typography variant='h3' className={classes.titel} color='secondary'>
                                <span style={{ fontWeight: 'bold' }}>HUNDE - </span>HAFTPFLICHT</Typography>
                            <Typography variant='h2' className={classes.plus} color='secondary'>+</Typography>
                        </div>
                    </div>
                </div>
            </Paper >
        </div >
    );

}

export default ProduktLogo;